import React from "react"
import { Box, Text } from "@chakra-ui/react"
import { PillShell } from "components/TemplateEditor/VariablePill"
import GripIcon from "../GripIcon"
import { MERGE_TAG_DRAG_TYPE } from "../constants"
import { applyMergeTagDragImage } from "../mergeTagDragImage"
import { setActiveMergeTagDrag } from "../mergeTagDragStore"

export type MergeFieldPillProps = {
  label: string
  tagId: string
  variant: "locked" | "selectable"
  disabled?: boolean
  draggable?: boolean
  selected?: boolean
  onInsert: (tagId: string) => void
  onInsertStart?: () => void
}

const MergeFieldPill = ({
  label, tagId, variant, disabled, draggable, selected, onInsert, onInsertStart,
}: MergeFieldPillProps) => (
  <Box
    as="span"
    display="inline-flex"
    outline={selected ? "2px solid" : undefined}
    outlineColor={selected ? "blue.400" : undefined}
    borderRadius="md"
    draggable={draggable && !disabled}
    cursor={disabled ? "not-allowed" : (draggable ? "grab" : "pointer")}
    _active={draggable && !disabled ? { cursor: "grabbing" } : undefined}
    onDragStart={(e: React.DragEvent<HTMLElement>) => {
      if (!draggable || disabled) return
      const payload = { nodeKey: null, tagId, tagLabel: label }
      setActiveMergeTagDrag(payload)
      e.dataTransfer.setData(MERGE_TAG_DRAG_TYPE, JSON.stringify(payload))
      e.dataTransfer.effectAllowed = "copy"
      applyMergeTagDragImage(e)
      onInsertStart?.()
    }}
    onClick={disabled ? undefined : () => onInsert(tagId)}
  >
    <PillShell variant={variant} size="md" cursor="inherit">
      {draggable && <GripIcon />}
      <Text
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        opacity={disabled ? 0.5 : 1}
      >
        {label}
      </Text>
    </PillShell>
  </Box>
)

export default MergeFieldPill
